import { render, staticRenderFns } from "./PersonaCobranzasView.vue?vue&type=template&id=38660583&scoped=true"
import script from "./PersonaCobranzasView.vue?vue&type=script&lang=js"
export * from "./PersonaCobranzasView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38660583",
  null
  
)

export default component.exports